function CGU() {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-gray-900 text-white rounded-lg shadow-lg mt-10 mb-10">
      <h1 className="text-2xl font-bold mb-4">
        Conditions Générales d’Utilisation (CGU)
      </h1>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">1. Objet du site</h2>
        <p>
          Ce site a pour but de présenter mes projets professionnels et
          personnels en tant que développeur. Il est destiné à informer les
          visiteurs sur mes compétences et réalisations.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">
          2. Propriété intellectuelle
        </h2>
        <p>
          L’ensemble du contenu de ce site (textes, images, vidéos, code) est ma
          propriété exclusive, sauf mention contraire. Toute reproduction ou
          utilisation sans autorisation est interdite.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">3. Responsabilité</h2>
        <p>
          Je ne peux être tenu responsable de tout dommage ou perte résultant de
          l’utilisation de ce site.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">4. Liens externes</h2>
        <p>
          Ce site peut contenir des liens vers des sites tiers. Je n’ai aucun
          contrôle sur leur contenu et ne peux être tenu responsable de leur
          utilisation.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">5. Données personnelles</h2>
        <p>Aucune donnée personnelle n’est collectée ou stockée sur ce site.</p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">6. Modification des CGU</h2>
        <p>
          Je me réserve le droit de modifier ces conditions à tout moment. Les
          modifications s’appliquent dès leur publication sur le site.
        </p>
      </section>

      <p className="mt-6 font-medium">
        En utilisant ce site, vous acceptez ces conditions d’utilisation.
      </p>
    </div>
  );
}

export default CGU;
